import { render, staticRenderFns } from "./gift-modal-after-purchase.vue?vue&type=template&id=1bffae1d&scoped=true&"
import script from "./gift-modal-after-purchase.vue?vue&type=script&lang=js&"
export * from "./gift-modal-after-purchase.vue?vue&type=script&lang=js&"
import style0 from "./gift-modal-after-purchase.vue?vue&type=style&index=0&id=1bffae1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bffae1d",
  null
  
)

export default component.exports